// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1SCVi","table":"Table_table__3QAPN","btn":"Table_btn__2bdXy"};